import React from 'react'
import FeaturesHero from '../components/FeaturesHero'
import FeaturesComponentTwo from '../components/FeaturesComponentTwo'
import FeaturesComponentThree from '../components/FeaturesComponentThree'
import FeaturesComponentFour from '../components/FeaturesComponentFour'
import FeaturesComponentFive from '../components/FeaturesComponentFive'

const Features = () => {
  return (
    <div>
      <FeaturesHero/>
      <FeaturesComponentTwo/>
      <FeaturesComponentThree/>
      <FeaturesComponentFour/>
      <FeaturesComponentFive/>
    </div>
  )
}

export default Features
